import { ValidationControlHelper } from "./ValidationControlHelper";
import { DateParser } from '@fnv-core/parsing/date/DateParser';
import { getResourceString } from '../../kentico/resource-strings';
import axios, { AxiosResponse } from 'axios';

export class ContributionHelper {

  public static async getContribution(state, prevContributionBody, setPrevContributionBody) : Promise<AxiosResponse<ContributionRate>> {
    if(state.formData["Geboortedatum"].value) {
      const content: ContributionRateData = {
        code: state.formData["broncode"],
        workSituation: state.formData["Situatie"]?.value ?? "",
        benefitType: state.formData["UitkeringVorm"]?.value ?? "",
        incomeType: state.formData["WatIsJeBrutoMaandinkomenStuderenDeeltijd"]?.value ?? state.formData["WatIsJeBrutoMaandinkomenWerkendUitzendkracht"]?.value ?? "",
        studyType: state.formData["StudieVorm"]?.value ?? "",
        workType: state.formData["WerkVorm"]?.value ?? "",
        birthday: new DateParser().parse(state.formData["Geboortedatum"].value, true).toISOString(),
      };
  
      if(JSON.stringify(content) !== JSON.stringify(prevContributionBody)) {
        setPrevContributionBody(content);
        return ContributionHelper.calculateContribution(content);
      }
    }

    return new Promise<AxiosResponse<ContributionRate>>((resolve) => { return resolve(null)});
  };

  public static async calculateContribution(content: ContributionRateData) : Promise<AxiosResponse<ContributionRate>> {
    try {
      var response = await axios.post<ContributionRate>(`/api/contribution/calculate`, content);
      return response;
    } catch (error) {
      throw new Error('Calculate contribution failed.');
    }
  };

  public static getVisibleConditionsIntroductionContribution(state: any) : (field: Field, formData: any, formErrors: any, fields: Field[], handleNewFormData: any, isVisible: boolean) => boolean {
    return (field: Field, formData: any, formErrors: any, fields: Field[], handleNewFormData: any, isVisible: boolean) : boolean => {
    
      if(field["@column"] != "Geboortedatum") {
        if(!formData["Geboortedatum"]?.touched || ValidationControlHelper.validateField(
            fields,
            "Geboortedatum", 
            formData,
            state.setFormData,
            handleNewFormData,
            true)?.length > 0) 
        {
          isVisible = false;
        }
      }
      return isVisible;
    }
  };

  public static getFieldManipulationsIntroductionContribution(
    state: any
  ) : (fields: Field[], formData: any) => Field[] {
    return (fields: Field[], formData: any) : Field[] => {
      
      if(!fields) {
        return [];
      }

      const newFields = [];

      for (let index = 0; index < fields.length; index++) {
        let field:Field = JSON.parse(JSON.stringify(fields[index]));

        // only 'Gepensioneerd' if Geboortedatum is 60 years or older
        if(field["@column"] == "UitkeringVorm" && 
          formData["Geboortedatum"]?.touched && 
          !ValidationControlHelper.dateIsValid(new DateParser().parse(formData["Geboortedatum"].value), 60)) {
            
          let options = field.settings.Options.split(/\r?\n/).map(option => {
            const [value, label] = option.split(';');
            return { value, label };
          });
          field.settings.Options = options
            .filter((option) => option.value !== "GEP")
            .map((option) => `${option.value};${option.label}`)
            .join('\n');
        }

        // show tooltip for Geboortedatum when birthday is within 2 months of now
        if(field["@column"] == "Geboortedatum" && formData["Geboortedatum"]?.value) {
          const date = new Date(formData["Geboortedatum"].value);
          const now = new Date();
          const thisYearBirthday = new Date(now.getFullYear(), date.getMonth(), date.getDate());
          const twoMonthsFromNow = new Date(now);
          twoMonthsFromNow.setMonth(now.getMonth() + 2);
      
          if (thisYearBirthday < now) {
            thisYearBirthday.setFullYear(now.getFullYear() + 1);
          }
        
          if(thisYearBirthday >= now && thisYearBirthday <= twoMonthsFromNow) {
            field.properties.fielddescription = getResourceString('Form.Lidworden.Geboortedatum.BirthdayWithin2Months');
          }
        }

        newFields.push(field);
      }
     
      return newFields;
    }
  };
}